module.exports = __webpack_public_path__ + "img/minus_btn.ccd3b449.png";